/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Request to merge two company types
 * @export
 * @interface CompanyTypeMergeRequest
 */
export interface CompanyTypeMergeRequest {
    /**
     * ID of the company type to be disabled (source)
     * @type {string}
     * @memberof CompanyTypeMergeRequest
     */
    sourceCompanyTypeId: string;
    /**
     * ID of the company type to keep (target)
     * @type {string}
     * @memberof CompanyTypeMergeRequest
     */
    targetCompanyTypeId: string;
    /**
     * When true, skips all validator checks and forces the merge
     * @type {boolean}
     * @memberof CompanyTypeMergeRequest
     */
    force?: boolean;
    /**
     * When true, only migrates companies that are currently non-compliant
     * @type {boolean}
     * @memberof CompanyTypeMergeRequest
     */
    onlyNonCompliant?: boolean;
    /**
     * When provided, only migrates this single company instead of firing the full merge.
     * The source company type is NOT disabled in this case.
     * 
     * @type {string}
     * @memberof CompanyTypeMergeRequest
     */
    freelancerCompanyId?: string;
}

/**
 * Check if a given object implements the CompanyTypeMergeRequest interface.
 */
export function instanceOfCompanyTypeMergeRequest(value: object): value is CompanyTypeMergeRequest {
    if (!('sourceCompanyTypeId' in value) || value['sourceCompanyTypeId'] === undefined) return false;
    if (!('targetCompanyTypeId' in value) || value['targetCompanyTypeId'] === undefined) return false;
    return true;
}

export function CompanyTypeMergeRequestFromJSON(json: any): CompanyTypeMergeRequest {
    return CompanyTypeMergeRequestFromJSONTyped(json, false);
}

export function CompanyTypeMergeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeMergeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceCompanyTypeId': json['sourceCompanyTypeId'],
        'targetCompanyTypeId': json['targetCompanyTypeId'],
        'force': json['force'] == null ? undefined : json['force'],
        'onlyNonCompliant': json['onlyNonCompliant'] == null ? undefined : json['onlyNonCompliant'],
        'freelancerCompanyId': json['freelancerCompanyId'] == null ? undefined : json['freelancerCompanyId'],
    };
}

export function CompanyTypeMergeRequestToJSON(value?: CompanyTypeMergeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sourceCompanyTypeId': value['sourceCompanyTypeId'],
        'targetCompanyTypeId': value['targetCompanyTypeId'],
        'force': value['force'],
        'onlyNonCompliant': value['onlyNonCompliant'],
        'freelancerCompanyId': value['freelancerCompanyId'],
    };
}

